import { useEffect, useState } from 'react';

/**
 * Smart skeleton hook that only shows skeleton after a delay
 * This prevents flashing on fast connections while still providing
 * loading feedback for slower connections
 */
export function useSmartSkeleton(isLoading: boolean, delay = 300) {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowSkeleton(false);
      return;
    }

    const timer = setTimeout(() => {
      if (isLoading) {
        setShowSkeleton(true);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [isLoading, delay]);

  return showSkeleton;
}
